import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { State, ExQuote } from './state.model';
import { environment } from './../environments/environment';
import { Location } from '@angular/common';
import { Router, NavigationEnd, Navigation, ActivatedRoute, NavigationStart } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  assets = environment.assetsUri;
  currentUrl: string;
  previousUrl: string;
  routes: string[] = [
    '',
    '/config/scanning',
    '/config/storage',
    '/action',
    '/thank'
  ];

  private_state = new Subject();
  state$ = this.private_state.asObservable();

  currentAction = new Subject();
  lastAction$: Observable<any> = this.currentAction.asObservable() ;

  state: State = {
    choice: null,
    howMuch: null,
    witness: null,
    busRes: null,
    howOften: null,
    zip: null
  };

  attribution = {
    lead_page: '',
    lead_type: '',
    lead_utm_campaign: '',
    lead_utm_term: '',
    lead_utm_content: '',
    lead_utm_name: '',
    lead_utm_medium: '',
    lead_source: '',
    standalone: null,
    success: false
  };

  thankMessage: SafeHtml;

  currentNavigation: Navigation;

  private _progress = new Subject();

  progress$: Observable<any> = this._progress.asObservable();

  displayTop = true;

  showSpinner = false;

  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private dom: DomSanitizer,
  ) {
    this.route.params.subscribe(params => {
      var success = params[success];
      if (success == 1) {
        this.attribution.success = true;
      }
    });
    this.currentNavigation = this.router.getCurrentNavigation();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this._progress.next(this.progress());
        this.private_state.next(this.state);
      }
    });
  }

  goBack() {
    this.location.back();
  }

  retailActive(active: boolean) {
    if (active) {
      this._progress.next(100);
    } else {
      this._progress.next(this.progress());
    }
  }

  private progress(url: string = this.currentUrl): number {
    switch (url) {
      case '/config/bus-res':
        return 29;
      case '/config/how-much':
      case '/config/how-much-business':
        return 42;
      case '/config/witness-prompt':
      case '/config/smallRes-witness-prompt':
        return 57;
      case '/config/how-often':
        return 71;
      case '/config/zip':
        return 75;
      case '/action':
      case '/action/paper':
      case '/action/hard-drives':
      case '/action/medical-waste':
      case '/action/promotional-items':
      case '/action/paper-retail':
      case '/action/electronics-recycling':
      case '/action/paper-electronics':
        return 86;
      case '/thank':
      case '/thank?success=1':
        return 100;
      default:
        return 15;
    }
  }

  updateState(property: string, newValue: any) {
    if (property == 'howMuch') {
      var value = '';
      switch (newValue) {
        case '4 to 9 boxes':
          value = '4 to 14 boxes';
          break;
        case '10 or more boxes':
          value = '15 or more boxes';
          break;
        default:
          value = newValue;
          break;
      }
      newValue = value;
    }
    this.state[property] = newValue;
  }
  refreshState(state) {
    this.state = {
      choice: null,
      howMuch: null,
      witness: null,
      busRes: null,
      howOften: null,
      zip: null
    };
    this.state = {...state};
  }
  setAttribution(key: string, value: string) {
    this.attribution[key] = value;
  }

  trustHtml(html: string): SafeHtml {
    return this.dom.bypassSecurityTrustHtml(html);
  }

  setThankMessage(message: string) {
    this.thankMessage = this.trustHtml(message);
  }
}
